import UazapiAPI from '../../api/uazapi';

const state = {
  uiFlags: {
    isFetching: false,
    isGeneratingQR: false,
    isDisconnecting: false,
  },
};

const getters = {
  getUIFlags($state) {
    return $state.uiFlags;
  },
};

const actions = {
  instanceInfo: async ({ commit }, { inbox_id, accountId }) => {
    commit('setUIFlag', { isFetching: true });
    try {
      const response = await UazapiAPI.instanceInfo({
        inbox_id,
        accountId,
      });
      commit('setUIFlag', { isFetching: false });
      return response;
    } catch (error) {
      commit('setUIFlag', { isFetching: false });
      throw error;
    }
  },

  generateQRCode: async ({ commit }, { inbox_id, accountId, phone_number }) => {
    commit('setUIFlag', { isGeneratingQR: true });
    try {
      const response = await UazapiAPI.generateQRCode({
        inbox_id,
        accountId,
        phone_number,
      });
      commit('setUIFlag', { isGeneratingQR: false });
      return response;
    } catch (error) {
      commit('setUIFlag', { isGeneratingQR: false });
      throw error;
    }
  },

  disconnectInstance: async ({ commit }, { inbox_id, accountId }) => {
    commit('setUIFlag', { isDisconnecting: true });
    try {
      const response = await UazapiAPI.disconnectInstance({
        inbox_id,
        accountId,
      });
      commit('setUIFlag', { isDisconnecting: false });
      return response;
    } catch (error) {
      commit('setUIFlag', { isDisconnecting: false });
      throw error;
    }
  },
};

const mutations = {
  setUIFlag($state, data) {
    $state.uiFlags = {
      ...$state.uiFlags,
      ...data,
    };
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
